import { updatePreferenceByKey } from '@creditsights/api-ui-web';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Article } from '../../models';
import { ArticleTableRow } from '../../models/ArticleTableRow';
import { PreferencesKey } from '../../services/services.constants';
import { Channels } from '../../utils/channels';
import { mapArticleListItemDtoToArticleTableRow } from '../articles/utils/article.mappers';
import { queryKeys } from '../queryKeyFactory';
import { MAX_RECENTLY_VIEWED_SAVED } from './useFetchRecentlyViewed';
import { mapArticleTableRowToArticleListItemDto, mapArticleToArticleListItemDto } from './utils/article.mappers';

export default (): UseMutationResult<void, void, Article, void> => {
  const queryClient = useQueryClient();
  return useMutation(async (article: Article) => {
    const recentlyViewedCache = queryClient.getQueryData<ArticleTableRow[]>([queryKeys.fetchRecentlyViewed.all]);
    const articleDto = mapArticleToArticleListItemDto(article);

    if (!recentlyViewedCache || articleDto.id === recentlyViewedCache[0]?.id) {
      return;
    }

    const articleListItems = mapArticleTableRowToArticleListItemDto(recentlyViewedCache);
    const deduplicatedList = articleListItems.filter((article) => article.id !== articleDto.id);
    const updatePreferencePayload = [articleDto, ...deduplicatedList].slice(0, MAX_RECENTLY_VIEWED_SAVED);
    const { value } = await updatePreferenceByKey(PreferencesKey.recentlyViewed, {
      value: updatePreferencePayload,
    });

    queryClient.setQueryData([queryKeys.fetchRecentlyViewed.all], mapArticleListItemDtoToArticleTableRow(value));
    Channels.recentlyViewedChannel.postMessage(value);
  });
};
